<script setup>
// A área onde um aplicativo aparece (aba da conversa ou tela cheia), com a
// barra dele: Início (volta para a URL cadastrada) e Nova aba (para site que
// não aceita abrir dentro de outro). O iframe em si fica na
// CamadaDeAplicativos e é posto por cima de `area`.
import { onBeforeUnmount, onMounted, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import Button from 'dashboard/components-next/button/Button.vue';
import { enderecoDe, esconde, mostra, recomeca } from './estado';
import messages from './i18n';

const props = defineProps({
  app: { type: Object, required: true },
});

const { t } = useI18n({ messages });
const area = ref(null);

onMounted(() => {
  if (enderecoDe(props.app)) mostra(props.app.id, area.value);
});
watch(
  () => props.app.id,
  (_, antigo) => {
    esconde(antigo, area.value);
    if (enderecoDe(props.app)) mostra(props.app.id, area.value);
  }
);
onBeforeUnmount(() => esconde(props.app.id, area.value));
</script>

<template>
  <div class="flex flex-col w-full h-full min-h-0">
    <div class="flex items-center gap-2 px-3 py-1.5 border-b border-n-weak">
      <span class="text-sm font-medium truncate text-n-slate-12 me-auto">
        {{ app.title }}
      </span>
      <Button
        size="xs"
        variant="ghost"
        color="slate"
        icon="i-lucide-house"
        :label="t('NEUXS_APLICATIVOS.INICIO')"
        :title="t('NEUXS_APLICATIVOS.INICIO_DICA')"
        @click="recomeca(app.id)"
      />
      <a
        v-if="enderecoDe(app)"
        :href="enderecoDe(app)"
        target="_blank"
        rel="noopener noreferrer"
        class="inline-flex items-center gap-1 px-2 py-1 text-xs rounded-lg text-n-slate-11 hover:bg-n-alpha-2"
        :title="t('NEUXS_APLICATIVOS.NOVA_ABA_DICA')"
      >
        <span class="i-lucide-external-link size-3.5" />
        {{ t('NEUXS_APLICATIVOS.NOVA_ABA') }}
      </a>
    </div>
    <div ref="area" class="relative flex-1 min-h-0">
      <p v-if="!enderecoDe(app)" class="p-4 m-0 text-sm text-n-slate-11">
        {{ t('NEUXS_APLICATIVOS.SEM_ENDERECO') }}
      </p>
    </div>
  </div>
</template>
